/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';
import { DRAWER_WIDTH_CLOSED, DRAWER_WIDTH_CLOSED_XS } from 'styles/theme';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { updateVendorDetails } from 'modules/authorizations/store/actions/dataManagement.actions';
import { UPDATE_VENDOR_DETAILS_FAILURE } from 'modules/authorizations/store/types/dataManagementTypes';
import { showToast } from 'modules/layout/layout.actions';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import VendorDetailsCard from './vendorDetailsCard.component';
import VendorTaxesEditableCard from './vendorTaxesEditableCard.component';
import ContactsCard from './contactsCard.component';
import DocumentsCard from './documentsCard.component';
import VendorsBankingInfoCard from './vendorsBankingInfoCard.component';
import queryString from 'query-string';
import VendorHistoryView from './vendorHistoryView.container';
import ClientVendorRelationshipGrid from './clientVendorRelationshipsCard.component';

const styles = theme => ({
  container: {
    height: 'auto',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    whiteSpace: 'nowrap',
    width: `calc(100% - ${DRAWER_WIDTH_CLOSED_XS}px)`,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${DRAWER_WIDTH_CLOSED}px)`
    }
  },
  headerFixed: {
    zIndex: 4
  },
  estimateHeaderFixed: {
    paddingTop: '115px',
    zIndex: 2
  },
  tabFixed: {
    zIndex: 3
  },
  previewTabFixed: {
    paddingTop: '10px',
    zIndex: 3
  }
});

const VendorDetails = props => {
  const {
    vendorDetails,
    vendorAddress,
    vendorContacts,
    vendorDocuments,
    vendorDesignations,
    vendorBanks,
    vendorHistory,
    voucherSummaries,
    vendorAuthNotes,
    expenseLines,
    location,
    enumerations,
    clientVendorRelationships,
    clients,
    score,
    isReadOnly,
    history,
  } = props;

  const [isLoading, setIsLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState(
    queryString.parse(location.search).tab ? queryString.parse(location.search).tab : 'VENDOR_PROFILE'
  );

  const updateStatus = async () => {
    setIsLoading(true);
    const basicVendorInfo = {
      vendorRecord: { ...vendorDetails },
      address: { ...vendorAddress },
      designations: [...vendorDesignations]
    }

    let newStatus = basicVendorInfo.vendorRecord.statusId === '63eb2a41-21f5-45ec-a89c-f957e3e92c79' ? '518606fc-a9fc-4c81-995e-1e335d44eb74' : '63eb2a41-21f5-45ec-a89c-f957e3e92c79';
    basicVendorInfo.vendorRecord.statusId = newStatus;
    basicVendorInfo.vendorRecord.statusUpdated = new Date().toISOString();

    let response = await props.updateVendorDetails(basicVendorInfo);
    if (response.type === UPDATE_VENDOR_DETAILS_FAILURE) {
      props.showToast('Failed to update vendor, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    } else {
      props.showToast('Vendor status updated successfully', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
    }
    setIsLoading(false);
  };

  const changeTab = tab => {
    setCurrentTab(tab);
    const values = queryString.parse(location.search);
    values.tab = tab;
    props.history.replace(`${location.pathname}?${queryString.stringify(values)}`);
  };

  return (
    <>
      {!isLoading && (
        <Box>
          <Paper square className={props.classes.headerFixed} sx={{ position: 'relative', width: '100%', boxSizing: 'border-box' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', boxSizing: 'border-box' }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', flexGrow: 1, minWidth: 0 }}>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '10px', minWidth: 0 }}>
                  <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', rowGap: '10px', paddingTop: '10px' }}>
                    <InfoBox label="Partner Id" value={vendorDetails?.vendorId} />
                    <InfoBox label="Partner Code" value={vendorDetails?.vendorCode} />
                    <InfoBox label="Company Name" value={vendorDetails?.companyName} />
                    <InfoBox label="Partner Type" value={vendorDetails && enumerations ? enumerations?.allEnums?.vendorTypes.find(vt => vt.id === vendorDetails?.vendorTypeId).title : ''} />
                    <InfoBox label="Status" value={vendorDetails && enumerations ? enumerations?.allEnums?.vendorStatuses.find(vs => vs.id === vendorDetails?.statusId).title : ''} />
                    <InfoBox label="Average Survey Score" value={score ? score : '-'} />
                    <InfoBox
                      label="Contract Date"
                      value={vendorDetails?.contractDate ? new Date(vendorDetails.contractDate).toLocaleDateString('en-US') : null}
                    />
                    <InfoBox
                      label="Contract Expires"
                      value={vendorDetails?.contractExpires ? new Date(vendorDetails.contractExpires).toLocaleDateString('en-US') : null}
                    />
                    <InfoBox
                      label="Status Updated"
                      value={
                        vendorDetails?.statusLastUpdated ? new Date(vendorDetails.statusLastUpdated).toLocaleDateString('en-US') : null
                      }
                    />
                  </Box>
                </Box>
              </Box>
              <Box sx={{ padding: '10px', flexShrink: 0 }}>
                <Button
                  color="secondary"
                  variant="contained"
                  sx={{
                    maxHeight: '40px',
                    marginLeft: '12px',
                    marginTop: '8px',
                    backgroundColor: '#ffffff',
                    '&:hover': { backgroundColor: '#faf8f2' },
                    color: '#080600'
                  }}
                  onClick={updateStatus}
                  disabled={isReadOnly}
                >
                  {vendorDetails?.statusId === '63eb2a41-21f5-45ec-a89c-f957e3e92c79' ? 'Set As Inactive' : 'Set As Active'}
                </Button>
              </Box>
            </Box>
          </Paper>
          <Paper square className={props.classes.tabFixed} sx={{ width: '100%' }}>
            <Tabs variant="fullWidth" value={currentTab} onChange={(event, tab) => changeTab(tab)} sx={{}}>
              <Tab value={'VENDOR_PROFILE'} label="Partner Profile" />
              <Tab value={'VENDOR_HISTORY'} label="Partner History" />
            </Tabs>
          </Paper>
          {currentTab === 'VENDOR_PROFILE' && (
            <Box sx={{ padding: '16px', paddingTop: '20px', boxSizing: 'border-box', overflowWrap: 'anywhere' }}>
              <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
                <Grid item xs={12} xl={8} rowSpacing={2} sx={{ minWidth: 0 }}>
                  <VendorDetailsCard
                    vendorDetails={vendorDetails}
                    vendorAddress={vendorAddress}
                    vendorDesignations={vendorDesignations}
                    isReadOnly={vendorDetails?.statusId !== '63eb2a41-21f5-45ec-a89c-f957e3e92c79' || isReadOnly}
                    enumerations={enumerations.allEnums}
                    history={history}
                  />
                  <Box sx={{ paddingTop: '16px' }}>
                    <ContactsCard vendorId={vendorDetails?.vendorId} vendorContacts={vendorContacts} enumerations={enumerations.allEnums} hideEdit={isReadOnly} />
                  </Box>
                  <Box sx={{ paddingTop: '16px' }}>
                    <DocumentsCard vendorId={vendorDetails?.vendorId} vendorDocuments={vendorDocuments} enumerations={enumerations.allEnums} isReadOnly={isReadOnly} />
                  </Box>
                  {vendorDetails?.hasBankingInformationRequired === true && (
                    <>
                      <Box sx={{ paddingTop: '16px' }}>
                        <VendorsBankingInfoCard
                          vendorBanks={vendorBanks}
                          isReadOnly={vendorDetails?.statusId !== '63eb2a41-21f5-45ec-a89c-f957e3e92c79' || isReadOnly}
                          vendorId={vendorDetails?.vendorId}
                          enumerations={enumerations.allEnums}
                          vendorAddress={vendorAddress}
                        />
                      </Box>
                    </>
                  )}
                </Grid>
                <Grid item xs={12} xl={4} rowSpacing={2} sx={{ minWidth: 0 }}>
                  <Box>
                    <VendorTaxesEditableCard
                      vendorDetails={vendorDetails}
                      vendorAddress={vendorAddress}
                      vendorDesignations={vendorDesignations}
                      isReadOnly={vendorDetails?.statusId !== '63eb2a41-21f5-45ec-a89c-f957e3e92c79' || isReadOnly}
                      enumerations={enumerations.allEnums}
                    />
                  </Box>
                  <Box sx={{ paddingTop: '16px' }}>
                    <ClientVendorRelationshipGrid
                      clientVendorRelationships={clientVendorRelationships}
                      vendorId={vendorDetails?.vendorId}
                      clients={clients}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
          {currentTab === 'VENDOR_HISTORY' && (
            <Box>
              {vendorDetails && vendorHistory && vendorHistory.length > 0 && (
                <Box sx={{ padding: 3 }}>
                  <VendorHistoryView
                    isLoading={isLoading}
                    vendorDetails={vendorDetails}
                    history={props.history}
                    expenseLines={expenseLines}
                    voucherSummaries={voucherSummaries}
                    vendorAuthNotes={vendorAuthNotes}
                    vendorHistory={vendorHistory}
                  />
                </Box>
              )}
            </Box>
          )}
        </Box>
      )}
      {isLoading && <FullscreenSpinner />}
    </>
  );
};

const InfoBox = ({ label, value }) => (
  <Box sx={{ paddingLeft: '10px', whiteSpace: 'nowrap' }}>
    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
      <Typography variant="subtitle2" sx={{ color: '#777667', fontWeight: 400, fontSize: '1rem', textAlign: 'center' }}>
        {label}
      </Typography>
    </Box>
    <Box sx={{ marginBottom: '4px', marginRight: '20px' }}>
      <Typography variant="body2" sx={{ color: '#43423a', fontWeight: 500, fontSize: '1rem', textAlign: 'center' }}>
        {value}
      </Typography>
    </Box>
  </Box>
);

const mapStateToProps = state => ({});

export default compose(withStyles(styles), connect(mapStateToProps, { showToast, updateVendorDetails }))(VendorDetails);
